import { useSubscriptionTypes } from 'helpers/subscription';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { convertCentsToBRL } from 'utils/currency';

interface TrialProps {
	offer;
	isCalculatingBumpsInterest: boolean;
	installmentValues: any;
	error: any;
	currency: string;
}

const Trial: React.FC<TrialProps> = ({ offer, isCalculatingBumpsInterest, installmentValues, error, currency }) => {
	const { t } = useTranslation('upsell');
	const subscriptionTypes = useSubscriptionTypes();
	const { next_charge_price, interval, trial_days, name, price } = offer;

	return (
		<p style={{ width: '350px' }}>
			{String(t('bumps.trial_message'))} <strong>{name}</strong> {String(t('bumps.with'))}{' '}
			<span>
				<strong style={{ color: 'green' }}>
					{trial_days} {String(t('bumps.days'))} {String(t('bumps.free'))}
				</strong>
				.{' '}
			</span>
			<span>
				{String(t('bumps.period'))} <b>{convertCentsToBRL(price, currency)} </b>
				{subscriptionTypes?.find(sub => sub.value === interval)?.label}{' '}
			</span>
			{Number(next_charge_price) > 0 ? (
				<span>
					{String(t('bumps.charge'))}{' '}
					<b>
						{convertCentsToBRL(next_charge_price, currency)} {interval}
					</b>
				</span>
			) : (
				<></>
			)}
		</p>
	);
};

export default Trial;
